// extracted by mini-css-extract-plugin
module.exports = {"SearchPanel":"ps_a bhs_cw bhs_jx bhs_jo bhs_a bhs_j bhs_ri bhs_rj","SearchPanel__icon":"ps_b bhs_ui bhs_hb bhs_ro bhs_tu","SearchPanel__input":"ps_c bhs_iv bhs_cx bhs_z"};